export default __webpack_public_path__ + "static/media/Group 14412.b84d2e0d.svg";